module.exports = __webpack_public_path__ + "img/about-ch3-2030agenda.e001bad0.svg";